import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CookiepolicyComponent } from './cookiepolicy/cookiepolicy.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { IAMServiceService } from './service/iamservice.service';
import { GlobalService } from './service/global.service';
import { HttpClientModule, provideHttpClient } from '@angular/common/http';
import { SharedComponent } from './shared/shared.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { AppconfigService } from './service/appconfig.service';
import { APP_INITIALIZER } from '@angular/core';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { provideRouter, withRouterConfig } from '@angular/router';
import { routes } from './app.routes';
import{ExtAuthenticationComponent} from "../app/ext-authentication/ext-authentication.component"
    

export function appConfigInit(appConfigService: AppconfigService) {
  return () => {
   // return appConfigService.loadConfig();
   return appConfigService.load();
  };
}

@NgModule({
  declarations: [
    AppComponent,
    SharedComponent,
    CookiepolicyComponent,
    ExtAuthenticationComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
   // AuthenticationModule,
    SharedModule,
    //HttpClientModule,
    NgxExtendedPdfViewerModule,
    NgIdleKeepaliveModule.forRoot()
  ],
  providers: [
    {provide: APP_INITIALIZER,
      useFactory: appConfigInit,
      multi: true,
      deps: [AppconfigService]
    },
    IAMServiceService,GlobalService,
    provideHttpClient(),
    // { provide: LocationStrategy, useClass: HashLocationStrategy },
    provideRouter(routes, withRouterConfig({ onSameUrlNavigation: 'reload' }))
     ],
  bootstrap: [AppComponent]
})
export class AppModule { }
